import { put, select } from 'redux-saga/effects';
import { selectSelectedLanguage } from '../userData/selectors';
import { api } from '../utils/api';
import etrApi from '../utils/etrApi';
import { enqueueErrorSnackbar } from '../notifications/actionWrapper';
import { translate } from '../../utils/translation';
import { returnSnackbarMessage } from '../utils/utils';
import { countriesSelector } from './selectors';

export function fetchBusinessUnitsSagaFactory(actions) {
  return function* () {
    const lang = yield select(selectSelectedLanguage);
    try {
      const { data } = yield etrApi.get('ppm/business-units');
      if (data) {
        yield put(actions.fetchBusinessUnitsSuccess(data));
        const countries = yield select(countriesSelector);
        yield put(actions.selectCountryCodes([countries[0]]));
      }
    } catch (e) {
      yield put(actions.fetchBusinessUnitsError(e));
      yield put(
        enqueueErrorSnackbar(
          returnSnackbarMessage(
            e,
            translate('snackbarMessages.problemGettingBusinessUnits', lang),
          ),
        ),
      );
    }
  };
}

export function fetchUsersBusinessUnitsSagaFactory(actions) {
  return function* () {
    const lang = yield select(selectSelectedLanguage);
    try {
      const { data } = yield api.get('business-units-list');
      if (data) {
        yield put(actions.fetchBusinessUnitsSuccess(data));
        const countries = yield select(countriesSelector);
        yield put(actions.selectCountryCodes([countries[0]]));
      }
    } catch (e) {
      yield put(actions.fetchBusinessUnitsError(e.message));
      yield put(
        enqueueErrorSnackbar(
          returnSnackbarMessage(
            e,
            translate('snackbarMessages.problemGettingBusinessUnits', lang),
          ),
        ),
      );
    }
  };
}
